/**
 * Custom hook to detect mobile device orientation (landscape or portrait).
 * Listens for orientation changes and updates state accordingly.
 * Useful for adjusting UI layout based on device orientation.
 * For local component decisions ("Should I show this in portrait?")
 */
import { useState, useEffect } from "react";

const useMobileOrientation = () => {
  const getOrientation = () => {
    let orientation = "landscape";
    if (window.screen.orientation) {
      orientation = window.screen.orientation.type.startsWith("landscape")
        ? "landscape"
        : "portrait";
    }
    if (orientation === "landscape") {
      return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
    }
    return orientation;
  };

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleChange = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener("resize", handleChange);
    window.addEventListener("orientationchange", handleChange);
    return () => {
      window.removeEventListener("resize", handleChange);
      window.removeEventListener("orientationchange", handleChange);
    };
  }, []);

  const isLandscape = orientation === "landscape";
  const isPortrait = orientation === "portrait";

  return {
    orientation,
    isLandscape,
    isPortrait,
  };
};

export default useMobileOrientation;
